import CreateRequestSuccessEvent from '@/domains/payments/features/paymentModals/shared/events/CreateRequestSuccessEvent';
import PaymentMethodSuccessEvent from '@/domains/payments/features/paymentModals/shared/events/PaymentMethodSuccessEvent';
import PaymentModalResetPayeeCacheEvent from '@/domains/payments/features/paymentModals/shared/events/PaymentModalResetPayeeCacheEvent';

const PaymentFormEvent = {
  CreateRequestSuccess: CreateRequestSuccessEvent,
  ResetPayeeCache: PaymentModalResetPayeeCacheEvent,
  PaymentMethodSuccess: PaymentMethodSuccessEvent,
};

export default PaymentFormEvent;
